/**
 * Export études RH en CSV — téléchargement navigateur
 */
const escapeCsv = (val) => {
  if (val == null) return '';
  const str = String(val);
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return '"' + str.replace(/"/g, '""') + '"';
  }
  return str;
};

const formatDate = (d) => {
  if (!d) return '';
  return new Date(d).toLocaleDateString('fr-FR');
};

export default function exportStudiesToCsv(studies) {
  const headers = ['Titre', 'Niveau', 'Domaine', 'Sous-domaine', 'Statut', 'Score RH', 'Localisation', 'Population', 'Début période', 'Fin période', 'Date création'];

  const rows = studies.map(s => [
    escapeCsv(s.title),
    escapeCsv(s.level),
    escapeCsv(s.domain),
    escapeCsv(s.sub_domain),
    escapeCsv(s.status),
    s.rh_score != null ? Number(s.rh_score).toFixed(4) : '',
    escapeCsv(s.location),
    s.population_size || '',
    formatDate(s.period_start),
    formatDate(s.period_end),
    formatDate(s.created_at)
  ].join(','));

  const csv = '\uFEFF' + headers.join(',') + '\n' + rows.join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `etudes-rh-${new Date().toISOString().split('T')[0]}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
